import { render, staticRenderFns } from "./delete-videos.vue?vue&type=template&id=128eb2e7&scoped=true&"
import script from "./delete-videos.vue?vue&type=script&lang=js&"
export * from "./delete-videos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128eb2e7",
  null
  
)

export default component.exports